import { useEffect } from 'react';

interface UseCallbackOnExitIntentArgs {
  enabled: boolean;
  callback: () => void;
}

/**
 * Hook which calls a callback when user intents to exit on Desktop
 * inspired by: https://webtips.dev/how-to-make-an-effective-exit-intent-popup-in-javascript
 * @param {boolean} enabled enable event listeners for exit intent
 * @param {function} callback function which will be called
 */
const useCallbackOnExitIntent = ({ enabled, callback }: UseCallbackOnExitIntentArgs) => {
  useEffect(() => {
    const callbackHandler = (event: MouseEvent) => {
      if (!event.relatedTarget) {
        callback();
      }
    };

    const startEvents = () => {
      document.addEventListener('mouseout', callbackHandler);
    };

    const stopEvents = () => {
      document.removeEventListener('mouseout', callbackHandler);
    };

    if (enabled) {
      startEvents();
    } else {
      stopEvents();
    }

    return () => {
      stopEvents();
    };
  }, [enabled, callback]);
};

export default useCallbackOnExitIntent;
